import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition, applyUrlDefaults } from './../../../wayfinder'
/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
export const index = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

index.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/content/{type}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
index.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return index.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
index.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
index.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: index.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
const indexForm = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
indexForm.get = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::index
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:33
* @route 'https://org.proexpert.app/org/content/{type}'
*/
indexForm.head = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: index.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

index.form = indexForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
export const show = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

show.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/content/{type}/{content}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
show.url = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            content: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        content: args.content,
    }

    return show.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
show.get = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
show.head = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: show.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
const showForm = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
showForm.get = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::show
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:80
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
showForm.head = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: show.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

show.form = showForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
export const preview = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preview.url(args, options),
    method: 'get',
})

preview.definition = {
    methods: ["get","head"],
    url: 'https://org.proexpert.app/org/content/{type}/{content}/preview',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
preview.url = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            content: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        content: args.content,
    }

    return preview.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
preview.get = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: preview.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
preview.head = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: preview.url(args, options),
    method: 'head',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
const previewForm = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
previewForm.get = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url(args, options),
    method: 'get',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentPreviewController::preview
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentPreviewController.php:20
* @route 'https://org.proexpert.app/org/content/{type}/{content}/preview'
*/
previewForm.head = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'get'> => ({
    action: preview.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'HEAD',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'get',
})

preview.form = previewForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:146
* @route 'https://org.proexpert.app/org/content/{type}'
*/
export const store = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/content/{type}',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:146
* @route 'https://org.proexpert.app/org/content/{type}'
*/
store.url = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { type: args }
    }

    if (Array.isArray(args)) {
        args = {
            type: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
    }

    return store.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:146
* @route 'https://org.proexpert.app/org/content/{type}'
*/
store.post = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:146
* @route 'https://org.proexpert.app/org/content/{type}'
*/
const storeForm = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::store
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:146
* @route 'https://org.proexpert.app/org/content/{type}'
*/
storeForm.post = (args: { type: string | number } | [type: string | number ] | string | number, options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: store.url(args, options),
    method: 'post',
})

store.form = storeForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::update
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:178
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
export const update = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

update.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/content/{type}/{content}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::update
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:178
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
update.url = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            content: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        content: args.content,
    }

    return update.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::update
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:178
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
update.put = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: update.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::update
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:178
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
const updateForm = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::update
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:178
* @route 'https://org.proexpert.app/org/content/{type}/{content}'
*/
updateForm.put = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: update.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

update.form = updateForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::taxonomy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:256
* @route 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy'
*/
export const taxonomy = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: taxonomy.url(args, options),
    method: 'put',
})

taxonomy.definition = {
    methods: ["put"],
    url: 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::taxonomy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:256
* @route 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy'
*/
taxonomy.url = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            content: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        content: args.content,
    }

    return taxonomy.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::taxonomy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:256
* @route 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy'
*/
taxonomy.put = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: taxonomy.url(args, options),
    method: 'put',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::taxonomy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:256
* @route 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy'
*/
const taxonomyForm = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: taxonomy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::taxonomy
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:256
* @route 'https://org.proexpert.app/org/content/{type}/{content}/taxonomy'
*/
taxonomyForm.put = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: taxonomy.url(args, {
        [options?.mergeQuery ? 'mergeQuery' : 'query']: {
            _method: 'PUT',
            ...(options?.query ?? options?.mergeQuery ?? {}),
        }
    }),
    method: 'post',
})

taxonomy.form = taxonomyForm

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::transition
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:222
* @route 'https://org.proexpert.app/org/content/{type}/{content}/transition'
*/
export const transition = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

transition.definition = {
    methods: ["post"],
    url: 'https://org.proexpert.app/org/content/{type}/{content}/transition',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::transition
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:222
* @route 'https://org.proexpert.app/org/content/{type}/{content}/transition'
*/
transition.url = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            type: args[0],
            content: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        type: args.type,
        content: args.content,
    }

    return transition.definition.url
            .replace('{type}', parsedArgs.type.toString())
            .replace('{content}', parsedArgs.content.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::transition
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:222
* @route 'https://org.proexpert.app/org/content/{type}/{content}/transition'
*/
transition.post = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::transition
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:222
* @route 'https://org.proexpert.app/org/content/{type}/{content}/transition'
*/
const transitionForm = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

/**
* @see \App\Domain\Content\Presentation\Http\Controllers\OrgContentController::transition
* @see app/Domain/Content/Presentation/Http/Controllers/OrgContentController.php:222
* @route 'https://org.proexpert.app/org/content/{type}/{content}/transition'
*/
transitionForm.post = (args: { type: string | number, content: string | number } | [type: string | number, content: string | number ], options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: transition.url(args, options),
    method: 'post',
})

transition.form = transitionForm

const content = {
    index: Object.assign(index, index),
    show: Object.assign(show, show),
    preview: Object.assign(preview, preview),
    store: Object.assign(store, store),
    update: Object.assign(update, update),
    taxonomy: Object.assign(taxonomy, taxonomy),
    transition: Object.assign(transition, transition),
}

export default content